import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { APP_BASE_HREF, DatePipe } from "@angular/common";
import { environment } from "src/environments/environment";
import { HeaderComponent } from "./header/header.component";
import { BlueRibbonComponent } from "./blue-ribbon/blue-ribbon.component";
import { ProjectsComponent } from "./projects/projects.component";
import { FooterComponent } from "./footer/footer.component";
import { ShowVersionComponent } from "./show-version/show-version.component";
import { SearchComponent } from "./search/search.component";
import { SearchPublicationComponent } from "./search-publication/search-publication.component";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { BaseComponent } from "./base/base.component";
import { IAppConfig } from "./services/Config/app-config.model";
import { AppConfig } from "./services/Config/app.config";
import { AuthInterceptor } from "./http-interceptors/auth-interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// RECOMMENDED
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgxSelectModule } from "ngx-select-ex";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DateValidatorDirective } from "./custom-validator/Date-Validator.directive";
import { DateValidatorService } from "./services/date-validator/date-validator.service";
import { DisableControlDirective } from "./shared/directives/disablecontrol.directive";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown";
import { ProjectDetailsComponent } from "./project-details/project-details.component";
import { SubmittalComponent } from "./submittal/submittal.component";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { FileUploadModule } from "ng2-file-upload";
import { UiSwitchModule } from "ngx-ui-switch";
import { PublicationsComponent } from "./publications/publications.component";
import { AttachmentsModalComponent } from "./attachments-modal/attachments-modal.component";
import { NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatChipsModule } from "@angular/material/chips";
import { YesNoPipe } from "./shared/pipes/yes-no.pipe";
import { Excel } from "./services/Excel/excel.service";
import { ModalContentComponent } from "./modal-content/modal-content.component";
import { QuillModule } from "ngx-quill";
import { RecentDecisionsComponent } from "./recent-decisions/recent-decisions.component";
import { BsModalService } from "ngx-bootstrap/modal";
import { MessageModalContentComponent } from "./message-modal-content/message-modal-content.component";
import { TooltipDirective } from "./shared/directives/tooltip.directive";
import { CustomDateAdapter } from "./UI-Components/CustomDateAdapter";
import { CustomDateParserFormatter } from "./UI-Components/CustomDateParseFormatter";
import { AttachmentsBaseComponent } from "./attachment-base/attachment-base.component";
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';

export function initializeApp() {
  return new AppConfig<IAppConfig>().load();
}
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    BlueRibbonComponent,
    ProjectsComponent,
    FooterComponent,
    ShowVersionComponent,
    SearchComponent,
    SearchPublicationComponent,
    BaseComponent,
    DateValidatorDirective,
    DisableControlDirective,
    ProjectDetailsComponent,
    SubmittalComponent,
    FileUploadComponent,
    PublicationsComponent,
    AttachmentsModalComponent,
    YesNoPipe,
    ModalContentComponent,
    RecentDecisionsComponent,
    MessageModalContentComponent,
    TooltipDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    PaginationModule.forRoot(),
    HttpClientModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    NgxSelectModule,
    FormsModule,
    AngularMultiSelectModule,
    ReactiveFormsModule,
    FileUploadModule,
    UiSwitchModule,
    NgbModule,
    MatChipsModule,
    QuillModule.forRoot(),
    ProgressbarModule.forRoot()
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseHref,
    },
    {
      provide: "appconfig",
      useFactory: initializeApp,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    DateValidatorService,
    DatePipe,
    Excel,
    BsModalService,
    {provide: NgbDateAdapter, useClass: NgbDateNativeAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter},
    AttachmentsBaseComponent
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
export function getBaseHref(): string {
  return environment.BASE_HREF;
}
